import { useState, DragEvent, ChangeEvent } from 'react';

import { trans } from "~/providers/lang";
// , imageFromFile
import { isPicture } from "~/utils/picture";
import { getItemInd } from "~/utils/utils";
import { useSeo } from "~/hooks/useSeo";

import "./style.less";

interface IImage {
	key: number;
	src: string;
	name: string;
	file: File;
	type: {
		name: string;
		id: string;
	};
	desc: string;
}

const TYPES = [{
	name: "Svatební",
	id: "svat",
}, {
	name: "Společenské",
	id: "spol",
}, {
	name: "Akce",
	id: "akce",
}, {
	name: "Polonéza",
	id: "polo",
}];

export default function UploadPage() {
	//const previewMaxSize = 200;
	const [state, setState] = useState<{
		isDrag: boolean;
		images: Array<IImage>;
		msg: string;
		status: number;
		uploaded: number;
		count: number;
	}>({
		isDrag: false,
		images: [],
		msg: "",
		status: 0,
		uploaded: 0,
		count: 0,
	});

	useSeo({
		title: trans("skelet.title.upload"),
		canonical: "nahravani",
	});

	function readFiles(files: FileList) {
		const images = Array.from(files).filter(item => isPicture(item)).map(item => ({
			key: Math.random(),
			src: URL.createObjectURL(item),
			name: item.name.replace(/[.].*$/u, ""),
			file: item,
			type: TYPES[0],
			desc: "",
		}));

		setState(prev => ({
			...prev,
			images: prev.images.concat(images),
		}));
	}

	function onDrop(event: DragEvent<HTMLLabelElement>) {
		event.stopPropagation();
		event.preventDefault();

		setState(prev => ({
			...prev,
			isDrag: false,
		}));

		readFiles(event.dataTransfer.files);
	}

	function getLabelClassName() {
		return ["file-div", ...state.isDrag ? ["hover"] : []].join(" ");
	}

	function getInfoClassName() {
		return [
			"info-cont",
			...state.status === -1 ? ["error"] : [],
			...state.status === 1 ? ["ok"] : [],
		].join(" ");
	}

	function onChange(event: ChangeEvent<HTMLInputElement>) {
		readFiles(event.target.files as FileList);
	}

	function onDragOver(event: DragEvent<HTMLLabelElement>) {
		event.stopPropagation();
		event.preventDefault();

		setState(prev => ({
			...prev,
			isDrag: true,
		}));
	}

	function onDragLeave(event: DragEvent<HTMLLabelElement>) {
		event.stopPropagation();
		event.preventDefault();

		setState(prev => ({
			...prev,
			isDrag: false,
		}));
	}

	function deleteItem(item: IImage) {
		const ind = getItemInd(state.images, (testItem: IImage) => testItem.src === item.src);

		if (ind !== -1) {
			setState(prev => {
				URL.revokeObjectURL(item.src);
				prev.images.splice(ind, 1);

				return {
					...prev,
				};
			});
		}
	}

	function changeType(event: ChangeEvent<HTMLSelectElement>, selItem: IImage) {
		const value = event.target.value;

		setState(prev => {
			const images = prev.images.slice();
			const imageItem = images.filter(item => selItem.key === item.key)[0];

			if (imageItem) {
				imageItem.type = TYPES.filter(item => item.id === value)[0];
			}

			return {
				...prev,
				images,
			};
		});
	}

	function changeDesc(event: ChangeEvent<HTMLInputElement>, selItem: IImage) {
		const value = event.target.value;

		setState(prev => {
			const images = prev.images.slice();
			const imageItem = images.filter(item => selItem.key === item.key)[0];

			if (imageItem) {
				imageItem.desc = value;
			}

			return {
				...prev,
				images,
			};
		});
	}

	async function send() {
		if (state.images.length) {
			// uploadPhoto
			const images = state.images.slice();
			const restImages: Array<IImage> = [];

			setState(prev => ({
				...prev,
				uploaded: 0,
				count: images.length + 1,
				msg: "Upload byl zahájen",
			}));

			/* eslint-disable no-await-in-loop */
			while (images.length) {
				const photo: IImage|undefined = images.shift();

				if (photo) {
					try {
						const formData = new FormData();

						formData.append("file", photo.file);
						formData.append("type", photo.type.id);
						formData.append("desc", photo.desc);

						const response = await fetch(`/upload.php`, {
							method: "POST",
							body: formData,
						});
						const jsonData = await response.json();

						if (jsonData.message === "ok") {
							setState(prev => ({
								...prev,
								uploaded: prev.uploaded + 1,
								msg: `Nahráno ${prev.uploaded + 1}/${prev.count}`,
							}));
						} else {
							restImages.push(photo);
						}
					} catch (exc) {
						/* eslint-disable no-console */
						console.log(exc);
						restImages.push(photo);
					}
				}
			}

			setState(prev => ({
				...prev,
				images: restImages,
				msg: `Upload byl ukončen ${prev.uploaded}/${prev.count}`,
			}));
		} else {
			setState(prev => ({
				...prev,
				msg: "Není co uploadovat!",
			}));
		}
	}

	return <div className="upload-page page-content">
		<div className="cont">
			<h2>Nahrát fotku</h2>
			<label className={getLabelClassName()} htmlFor="fileInput" onDrop={onDrop} onDragOver={onDragOver} onDragLeave={onDragLeave} >
				Kliknutím vyberte fotku z počítače nebo ji sem jednoduše přetáhněte
				<input type="file" id="fileInput" multiple={true} onChange={onChange} />
			</label>
			<div className="previews">
				<h2>Náhledy</h2>
				<div className="preview-items">
					{state.images.map(item => <span className="preview-item" key={item.key}>
						<span className="canvas-cover" style={{ height: "200px" }}>
							<img src={item.src} alt="" />
						</span>
						<select value={item.type.id} onChange={event => changeType(event, item)}>
							{TYPES.map(typeItem => <option value={typeItem.id} key={typeItem.id}>{typeItem.name}</option>)}
						</select>
						<input type="text" value={item.desc} placeholder="popisek" onChange={event => changeDesc(event, item)}/>
						<span className="title">{item.name}</span>
						<button className="delete-btn" type="button" onClick={() => deleteItem(item)}>
							Smazat
						</button>
					</span>)}
				</div>
			</div>
			<div className="done-buttons">
				<button type="button" className="done-btn" onClick={send}>Odeslat</button>
			</div>
			<div className={getInfoClassName()}>
				<p>{state.msg}</p>
			</div>
		</div>
	</div>;
}
